// extracted by mini-css-extract-plugin
module.exports = {"notifMarker":"notif-dot_notifMarker__1hwYB"};